import { render, staticRenderFns } from "./RoundedSquareChecked.vue?vue&type=template&id=16ff329f&scoped=true&"
var script = {}
import style0 from "./RoundedSquareChecked.vue?vue&type=style&index=0&id=16ff329f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff329f",
  null
  
)

export default component.exports